export default "__VITE_ASSET__B1my469v__"